import React from "react";

function DeveloperCard({ stats = {} }) {
  const cards = [
    {
      title: "Total Projects",
      value: stats?.totalProjects || 0,
      icon: "ti ti-briefcase",
      className: "stat-primary",
    },
    {
      title: "Pending",
      value: stats?.pendingProjects || 0,
      icon: "ti ti-clock",
      className: "stat-warning",
    },
    {
      title: "In Progress",
      value: stats?.inProgressProjects || 0,
      icon: "ti ti-loader-2",
      className: "stat-info",
    },
    {
      title: "Completed",
      value: stats?.completedProjects || 0,
      icon: "ti ti-circle-check",
      className: "stat-success",
    },
    {
      title: "High Priority",
      value: stats?.highPriorityProjects || 0,
      icon: "ti ti-alert-triangle",
      className: "stat-danger",
    },
    {
      title: "Testing",
      value: stats?.testingProjects || 0,
      icon: "ti ti-bug",
      className: "stat-primary",
    },
    {
      title: "Assigned Bugs",
      value: stats?.assignedBugs || 0,
      icon: "ti ti-bug",
      className: "stat-danger",
    },
    {
      title: "Open Bugs",
      value: stats?.openBugs || 0,
      icon: "ti ti-alert-circle",
      className: "stat-warning",
    },
    {
      title: "Fixed Bugs",
      value: stats?.fixedBugs || 0,
      icon: "ti ti-check",
      className: "stat-success",
    },
    {
      title: "Overdue",
      value: stats?.overdueProjects || 0,
      icon: "ti ti-calendar-x",
      className: "stat-warning",
    },
  ];

  return (
    <div className="row g-3 mb-4 modern-stat-row">
      {cards.map((card) => (
        <div
          className="col-xl-3 col-lg-4 col-sm-6 d-flex"
          key={card.title}
        >
          <div
            className={`card modern-stat-card ${card.className} flex-fill`}
          >
            <div className="card-body">
              <div className="stat-top">
                <div>
                  <p>{card.title}</p>

                  <h3>{card.value}</h3>
                </div>

                <div className="stat-icon">
                  <i className={card.icon} />
                </div>
              </div>

              <div className="stat-wave" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default DeveloperCard;